import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {StyledDetailsHeader} from '@components/commons/details-header/style.ts'
import {FC, ReactNode} from 'react'
import {ConversationToggle} from '@/features/conversations/components/conversation-toggle/ConversationToggle'
import {usePermissions} from '@/features/auth/store/store'

export const DetailsHeader: FC<{
    title: ReactNode
    className?: string
    subtitle?: ReactNode
    startSlot?: ReactNode
    endSlot?: ReactNode
    patientId?: string
    patientName?: string
    showConversationToggle?: boolean
}> = ({title, subtitle, className, startSlot, endSlot, patientId, patientName, showConversationToggle}) => {
    const permissions = usePermissions()

    return (
        <StyledDetailsHeader className={className}>
            <Flexbox gap={3} align="center">
                {startSlot}
                <Flexbox direction="column" gap={1}>
                    <h1>{title}</h1>
                    {!!subtitle && <h2>{subtitle}</h2>}
                </Flexbox>
            </Flexbox>
            {endSlot && (
                <Flexbox align="center" gap={2}>
                    {patientId && permissions?.conversations?.read && showConversationToggle && (
                        <ConversationToggle patientId={patientId} patientName={patientName} />
                    )}
                    {endSlot}
                </Flexbox>
            )}
        </StyledDetailsHeader>
    )
}
